import React from "react";
import PropTypes from "prop-types";

const ITManagedDevicesForm = ({ onChange, inputs }) => (
  <React.Fragment>
    <fieldset>
      <legend>IT Managed Devices </legend>
    </fieldset>
    <div className="it-hs-form">
      <div>
        <span>Managed Servers</span>
        <div className="slidecontainer">
          <input
            className="form-control"
            type="number"
            min="0"
            step="1"
            value={inputs.servers}
            name="servers"
            onChange={(e) =>
              onChange(e.target.name, parseInt(e.target.value, 10))
            }
          />
        </div>
      </div>

      <div>
        <span>Managed Workstations</span>
        <div className="slidecontainer">
          <input
            className="form-control"
            type="number"
            min="0"
            step="1"
            value={inputs.workstations}
            name="workstations"
            onChange={(e) =>
              onChange(e.target.name, parseInt(e.target.value, 10))
            }
          />
        </div>
      </div>

      <div>
        <span>Device Monitoring</span>
        <input
          className="form-control"
          type="number"
          min="0"
          step="1"
          value={inputs.device_monitoring}
          name="device_monitoring"
          onChange={(e) =>
            onChange(e.target.name, parseInt(e.target.value, 10))
          }
        />
      </div>
      <div>
        <span>Maintenance Alerts Resolved</span>
        <input
          className="form-control"
          type="number"
          min="0"
          step="1"
          value={inputs.maintenance_alerts_resolved}
          name="maintenance_alerts_resolved"
          onChange={(e) =>
            onChange(e.target.name, parseInt(e.target.value, 10))
          }
        />
      </div>
    </div>
  </React.Fragment>
);

ITManagedDevicesForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

ITManagedDevicesForm.defaultProps = {
  inputs: {},
  onChange: () => null
};

export default ITManagedDevicesForm;
